import styles from "./Footer.module.css";

function Footer() {
  return <p className={styles.footer}>&copy; coin-bounce 2023</p>;
}

export default Footer;
